import BottomNavigation from "./BottomNavigation";
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  Redirect,
} from "react-router-dom";
import Management from "../admin/Management";
import "./Home.css";
import Profile from "../profile/Profile";
import Reports from "../reports/Reports";
import ReportData from "../reports/ReportData";
import Lessons from "../lessons/Lessons";
import Students from "../students/Students";
import Student from "../students/student/Student";
import Farm from "../admin/farm/Farm";
import jwt_decode from "jwt-decode";

const Home = () => {
  let { path } = useRouteMatch();
  const history = useHistory();

  const onSet = (route) => {
    history.replace(`/dashboard/${route}`);
  };

  return (
    <div id="home">
      <div id="container">
        <Switch>
          <Route path={`${path}/profile`} exact>
            <Profile />
          </Route>
          <RoleRoute roleForRoute="admin" path={`${path}/management`}>
            <Management />
          </RoleRoute>
          <RoleRoute roleForRoute="admin" path={`${path}/farm/:id`}>
            <Farm />
          </RoleRoute>
          <RoleRoute roleForRoute="manager" path={`${path}/reports`} exact>
            <Reports />
          </RoleRoute>
          <RoleRoute roleForRoute="manager" path={`${path}/reports/:id`}>
            <ReportData />
          </RoleRoute>
          <RoleRoute roleForRoute="user" path={`${path}/lessons`}>
            <Lessons />
          </RoleRoute>
          <RoleRoute roleForRoute="user" path={`${path}/students`} exact>
            <Students />
          </RoleRoute>
          <RoleRoute roleForRoute="user" path={`${path}/students/:id`}>
            <Student />
          </RoleRoute>
        </Switch>
      </div>
      <BottomNavigation onSet={onSet} />
    </div>
  );
};

function RoleRoute({ roleForRoute, children, ...rest }) {
  const token = localStorage.getItem("token");
  const decoded = jwt_decode(token);
  const isApprovedForRoute = decoded.roles.includes(roleForRoute);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isApprovedForRoute ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default Home;
